import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ERoleType } from '../models/model.model';
import { UserService } from '../services/user/user.service';

export const roleGuard: CanActivateFn = (route, state) => {
  const platformId = inject(PLATFORM_ID);
  const router = inject(Router);
  if (!isPlatformBrowser(platformId)) {
    return false;
  }
  const userService = inject(UserService);
  const role = route.data['role'] as string;

  if (!role) {
    throw new Error('RoleGuard: Role not provided in route data');
  }

  if (!userService.user) {
    return false;
  }

  const canAccess =
    userService.user.role.type === role ||
    userService.user.role.type === ERoleType.SUPER_ADMIN;
  if (!canAccess) {
    return router.createUrlTree(['/not-authorized']);
  }

  return canAccess;
};
